module.exports = __webpack_public_path__ + "static/media/shaker_02_small.9639cd4f.jpg";